import { AssetTypes } from '@tassat/common-definitions';
import React from 'react';

import { useAppSelector } from 'Reducers/store/hooks';
import { getAssetFromTicker } from 'Selectors/assets';

type TransactionAssetCellRendererProps = {
    value: string;
};

export const TransactionAssetCellRenderer = (props: TransactionAssetCellRendererProps) => {
    const asset = useAppSelector((state) => getAssetFromTicker(state, props.value));

    let assetDisplay = 'UNK';
    if (asset?.Type === AssetTypes.CURRENCY) {
        assetDisplay = asset.Curcode;
    } else if (asset?.Type === AssetTypes.ASSET) {
        assetDisplay = asset.Ticker;
    }

    return (<span>{assetDisplay}</span>);
};

export default TransactionAssetCellRenderer;